import { RegistrationCrudSchema } from '@diamond/shared/schema/registration';
import { Format } from '@sinclair/typebox/format';
import { Value } from '@sinclair/typebox/value';

import type { RegistrationProgressResponse } from './status-display';

const progressResponseSchema = RegistrationCrudSchema.getProgress.response;
const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

if (!Format.Has('uuid')) {
  Format.Set(
    'uuid',
    (value) => typeof value === 'string' && UUID_REGEX.test(value)
  );
}

function unwrapProgressPayload(body: unknown): unknown {
  if (!body || typeof body !== 'object') {
    return body;
  }

  const record = body as Record<string, unknown>;
  const wrapped = record['data'];

  if (
    wrapped &&
    typeof wrapped === 'object' &&
    'registration_id' in (wrapped as Record<string, unknown>)
  ) {
    return wrapped;
  }

  return body;
}

export function parseRegistrationProgressResponse(
  body: unknown
): RegistrationProgressResponse {
  const candidate = unwrapProgressPayload(body);

  if (!Value.Check(progressResponseSchema, candidate)) {
    throw new Error('Gagal mengambil progres registrasi.');
  }

  return candidate;
}
